module.exports = __webpack_public_path__ + "static/media/presentionChart.19e2a500.svg";